import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChatBubblesModal } from 'components/Chat/ChatBubbles';
import { useMediaQuery } from '@material-ui/core';
import TopBar from 'scenes/HomePatient2/TopBar';
import UnreadBadge from 'components/Common/UnreadBadge';
import Icon from 'components/Utils/NewIcon';
import { useAppSelector } from 'careand-redux/store';
import MobileExpand from '../../Common/MobileExpand';

/**
 * @param {any} props
 */
const GenericDirectory = ({
  title,
  className = '',
  children,
  topRowContent,
  mobileRightElement,
  inlineRightElement,
  showTopRowMobile = false,
}) => {
  const [showBubbles, setShowBubbles] = useState(false);
  const isPhone = useMediaQuery('(max-width: 767px)');

  function onClickChat() {
    setShowBubbles(true);
  }

  const unreadCount = useAppSelector((state) => state.ui.bubbles.length);

  const rightElement = mobileRightElement ?? (showTopRowMobile ? topRowContent : null);

  return (
    <div className={'directory generic-directory ' + className}>
      {title !== undefined && (
        <>
          <div className={'top-row'}>
            <span className="large-title">{title}</span>
            {topRowContent}
          </div>
          <TopBar
            title={title}
            leftElement={
              <div className="messages-wrapper">
                <UnreadBadge unreadCount={unreadCount} />
                <Icon src="messages" height="20px" onClick={onClickChat} />
              </div>
            }
            rightElement={
              inlineRightElement ? rightElement : <MobileExpand children={rightElement} />
            }
          />
        </>
      )}
      <ChatBubblesModal
        isOpen={showBubbles && isPhone}
        onRequestClose={() => setShowBubbles(false)}
      />
      <div className="row big-box directory-content-wrapper">{children}</div>
    </div>
  );
};

GenericDirectory.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

export default GenericDirectory;
